import React, { useState } from 'react';
import classNames from 'classnames';
import Swiper from 'react-id-swiper';
import { Link } from 'gatsby';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { useUpdates } from 'context/updates';
import { Title } from '../typography';
import CircularArrow from '../circularArrow';
import { ClockIcon } from '../icons';
import { SWIPER_SETTINGS } from 'config';
import {
  updatesTab,
  updateColumn,
  isActive,
  updateCover,
  updateSummary,
  updateTitle,
  postDate,
  updatesLink,
  updateLink,
  postArrow,
  carouselContainer,
} from './scss/UpdatesTab.module.scss';

const UpdatesTab = () => {
  const updates = useUpdates();
  const [activeColumn, setActiveColumn] = useState(0);
  const updateItems = updates
    .slice(0, 5)
    .map(({ jetpack_featured_media_url, title, date, slug }, index) => {
      const isActiveColumn = activeColumn === index;

      return (
        <div
          className={classNames(updateColumn, {
            [isActive]: isActiveColumn,
          })}
          key={index}
          onMouseEnter={() => setActiveColumn(index)}
        >
          <LazyLoadImage
            src={jetpack_featured_media_url}
            className={updateCover}
            alt={title}
            effect="blur"
          />
          <div className={updateSummary}>
            <div>
              <span className={postDate}>
                <ClockIcon /> {date}
              </span>
              <Link to="/updates" className={updatesLink}>
                UPDATES
              </Link>
            </div>
            <Link className={updateLink} to={slug}>
              <Title
                renderAsHtml
                className={updateTitle}
                value={title}
                size="md"
                fontStyle="regular"
              />
            </Link>
          </div>
          <Link to={slug}>
            <CircularArrow className={postArrow} size="sm" />
          </Link>
        </div>
      );
    });

  return (
    <>
      <div className={classNames('d-none d-lg-flex', updatesTab)}>
        {updateItems}
      </div>
      <div className={classNames(carouselContainer, 'd-lg-none')}>
        <Swiper {...SWIPER_SETTINGS}>{updateItems}</Swiper>
      </div>
    </>
  );
};

export default UpdatesTab;
